/**
 * Shared signing utilities for Piezo thick clients.
 *
 * Provides httpAuthSchemeProvider overrides for per-endpoint SigV4 signing names.
 * Smithy-generated clients hardcode a single signing name from the model, but
 * RIP data provides per-endpoint signing names (e.g., "issuer-alps-a", "clerk-cascades-b").
 */
/**
 * Creates a custom httpAuthSchemeProvider that overrides the SigV4 signing name.
 *
 * @param signingName The per-endpoint signing name from RIP (e.g., "issuer-alps-a")
 * @returns An httpAuthSchemeProvider function compatible with Smithy-generated client config
 */
export function createSigningNameOverrideProvider(signingName) {
    return (authParameters) => [{
            schemeId: "aws.auth#sigv4",
            signingProperties: {
                signingName: signingName,
                signingRegion: authParameters.region,
            },
            propertiesExtractor: (_config, _context) => ({
                signingProperties: { config: _config, context: _context },
            }),
        }];
}
